import React from 'react';
import { Clock } from 'lucide-react';

interface GameModeDisplayProps {
  sessionMode: any;
  rushTimeRemaining: number | null;
  isMobile: boolean;
}

const GameModeDisplay: React.FC<GameModeDisplayProps> = ({ sessionMode, rushTimeRemaining, isMobile }) => {
  if (sessionMode.type !== 'rush' || rushTimeRemaining === null || rushTimeRemaining <= 0) {
    return null;
  }

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className={`flex items-center gap-0.5 sm:gap-1 bg-danger px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full animate-pulse`}>
      <Clock size={isMobile ? 12 : 16} className="text-white" />
      <span className="font-bold text-xs text-white">
        {isMobile ? formatTime(rushTimeRemaining) : `RUSH: ${formatTime(rushTimeRemaining)}`}
      </span>
    </div>
  );
};

export default GameModeDisplay;
